import React from "react";
import ComingSoon from '../../components/CommingSoon/CommingSoon';
import styles from './Settings.module.css'
import Footer from "../../components/common/Footer/Footer";

const Settings = () => {



    return (
      <div className={styles.container}>
      <ComingSoon />
      <Footer></Footer>
      </div>
      
  );
}

export default Settings; 